import React from "react"
import { Modal, Form, Input, message } from "antd"
import lodash from "lodash"
import PropTypes from 'prop-types'

class PackageComponentEditFormModal extends React.PureComponent {

  constructor(props) {
    super(props)

    const { formData } = this.props

    this.state = {
      formData: {
        key: formData.key,
        name: formData.name,
        iconType: lodash.toString(formData.iconType)
      }
    }

    this.iconFileInput = React.createRef()
  }

  onCancel() {
    this.props.onCancel()
  }

  onSubmit() {
    const { formData } = this.state

    // 表单数据校验
    if (!formData.key) {
      return message.warn("请输入组件标识")
    }

    if (!formData.name) {
      return message.warn("请输入组件名称")
    }

    // 检查上传的文件，仅新建时必传
    const iconFile = this.iconFileInput.current.files[0]

    const _formData = {
      ...formData,
      iconFile: iconFile
    }

    this.props.onSubmit(_formData)
  }

  updateFormData(inputData) {
    const { formData } = this.state

    const newFormData = {
      ...formData,
      ...inputData
    }
    this.setState({
      formData: newFormData
    })
  }

  render() {

    const { formData } = this.state

    const { title, isNew, iconUrl } = this.props

    const iconFileItemLabel = (
      <span>
        <span>组件图标</span>
        <span style={{ fontSize: 12, marginLeft: 4, color: "#999" }}>
          (svg格式{!isNew && ", 不需要更改组件图标时可以不传"})
        </span>
      </span>
    )

    return (
      <Modal
        title={title}
        visible={true}
        maskClosable={false}
        keyboard={false}
        width={500}
        okText='保存'
        cancelText='取消'
        onOk={() => this.onSubmit()}
        onCancel={() => this.onCancel()}
      >
        <Form layout="vertical">
          <Form.Item label="组件标识">
            <Input
              placeholder="请输入组件标识"
              style={{ width: "100%" }}
              value={formData.key}
              onChange={(e) => this.updateFormData({ "key": e.target.value })}
            />
          </Form.Item>
          <Form.Item label="组件名称">
            <Input
              placeholder="请输入组件名称"
              style={{ width: "100%" }}
              value={formData.name}
              onChange={(e) => this.updateFormData({ "name": e.target.value })}
            />
          </Form.Item>
          <Form.Item label={iconFileItemLabel}>
            <div>
              <input type="file" ref={this.iconFileInput} />
            </div>
            {iconUrl && (
              <div style={{ marginTop: 10 }}>
                <img src={iconUrl} style={{ maxHeight: "40px", maxWidth: "40px" }} />
              </div>
            )}
          </Form.Item>
          <Form.Item label={(
            <span>
              <span>预设图标类型</span>
              <span style={{ fontSize: 12, marginLeft: 4, color: "#999" }}>(兼容旧版)</span>
            </span>
          )}>
            <Input
              placeholder="请输入图标类型"
              style={{ width: "100%" }}
              value={formData.iconType}
              onChange={(e) => this.updateFormData({ "iconType": e.target.value })}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

PackageComponentEditFormModal.propTypes = {
  isNew: PropTypes.bool,
  title: PropTypes.string,
  iconUrl: PropTypes.string,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
}

export default PackageComponentEditFormModal
